/**
 * Listing draft meta shown in Staging — only keys stored on the listing document.
 * @param {Object} [listingMeta]
 * @returns {Object}
 */
export function resolveStagingListingMeta(listingMeta) {
  return listingMeta || {};
}

/**
 * Variant meta shown in Staging. Master meta is used only for read-only preview
 * when the variant is not yet on the listing channel.
 *
 * @param {Object} params
 * @param {string} [params.variantId]
 * @param {boolean} [params.isMasterPreview]
 * @param {Object} [params.masterVariantMeta]
 * @param {Object} [params.listingVariantMeta]
 * @returns {Object}
 */
export function resolveStagingVariantMeta({
  variantId,
  isMasterPreview,
  masterVariantMeta,
  listingVariantMeta,
}) {
  if (!variantId) return {};
  if (isMasterPreview) return masterVariantMeta || {};
  return listingVariantMeta || {};
}
